import { LitElement, html, css } from 'lit';
import './availability_notification_create_button';
import { restMethods } from '../mixins/rest_methods';
import { createSuccessBar } from '../packs/notification_bar'

class AvailabilityNotificationButtonsInShow extends LitElement {
  static properties = {
    id: { type: Number, reflect: true},
    isLogin: { type: Boolean, reflect: true},
    isPaidUser: { type:Boolean, reflect: true},
    isAdmin: { type: Boolean, reflect: true },
    disabled: { type: Boolean, reflect: true },
    availabilityNotificationsCount: { type: Number, reflect: true },
    isDisplayAvailability: { type: Boolean, reflect: true },
    requestedAvailability: { type: Boolean, reflect: true, attribute: false },
    hasCustomerId: { type: Boolean, reflect: true},
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.isLogin = false;
    this.isPaidUser = false;
    this.isAdmin = false;
    this.availabilityNotificationsCount = 0;
    this.isDisplayAvailability = false;
    this.hasCustomerId = false;
    this.requestedAvailability = localStorage.getItem(`request_facility_availability_${this.id}`)
    window.setInterval(() => {
      this.requestedAvailability = localStorage.getItem(`request_facility_availability_${this.id}`)
    }, 1000)
  }
  async addNotification(event) {
    const params = {
      facility_id: this.id,
      start_date: event.detail.startDate,
      end_date: event.detail.endDate,
    }
    const res = await restMethods.methods.postMethod('/availability_notifications', {availability_notification: params})
    if(res.status === 201){
      createSuccessBar(`
        <div>空き状況の通知を登録しました</div>
        <div>通知内容の確認は<a href="/mypage#availability_notification_edit">マイページ</a>から行えます</div>
      `);
    } else {

    }
    this.availabilityNotificationsCount = await this.getAvailabilityNotificationsCount();
  }
  static styles = css`
    .notification-buttons {
      display: flex;
      gap: 8px;
      margin-bottom: 18px;
      padding: 0 15px;
      justify-content: end;
    }
    .orange-outline-square-button {
      font-family: Noto Sans JP;
      background-color: transparent;
      display: flex;
      padding: 9px 12px;
      align-items: center;
      gap: 4px;
      border-radius: 4px;
      border: 2px solid #D76315;

      color: #D76315;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 175%; 
    }
    .orange-outline-square-button.disabled {
      color: #A8ABA6;
      border: 2px solid #A8ABA6;
    }
    .gray-outline-square-button {
      text-decoration: none;
    }
    .gray-outline-square-button button {
      font-family: Noto Sans JP;
      background-color: transparent;
      position: relative;
      display: flex;
      padding: 9px 12px;
      align-items: center;
      gap: 4px;
      border-radius: 4px;
      border: 2px solid #A8ABA6;

      color: #A8ABA6;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 175%;
    }
    .gray-outline-square-button button .badge {
      position: absolute;
      top: -13px;
      right: -13px;
      color: white;
      background-color: #D76315;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      font-family: "Noto Sans JP";
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 180%; 
      display: flex;
      justify-content: center;
    }
  `
  async getAvailabilityNotificationsCount() {
    const res = await restMethods.methods.getMethod(`/facilities/${this.id}/availability_notifications_count`)
    if(res.status === 200){
      return res.data
    }
    return 0
  }
  async requestAvailability() {
    console.log('requestAvailability')
    const res = await restMethods.methods.postMethod(`/facilities/${this.id}/request_availability`)
    localStorage.setItem(`request_facility_availability_${this.id}`, 'true')
    if(res.status === 200){
      createSuccessBar('この施設の“空き状況の取得”をリクエストしました。気長にお待ちいただけますと幸いです。');
      this.requestedAvailability = true
      return true
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'request_scraping',
      facility_id: this.id
    });

    return 0
  }
  renderEditButton() {
    return html`
      <a 
          class="gray-outline-square-button"
          href="/mypage#availability_notification_edit"
      >
        <button>
          <span>通知を編集</span>
          <img src="/images/gray-bell-icon.svg"/>
          <div class="badge">
            ${this.availabilityNotificationsCount}
          </div>
        </button>
      </a>
    `;
  }
  renderRequestButton() {
    return html`
      <button
        class="orange-outline-square-button ${this.requestedAvailability ? 'disabled' : ''}"
        @click="${this.requestAvailability}"
        ?disabled="${this.requestedAvailability}"
      >
        この施設の“空き状況取得”をリクエストする
        ${this.requestedAvailability ? html `<img src="/images/gray-add-comment.svg"/>` : html `<img src="/images/orange-add-comment.svg"/>`}
      </button>
    `;
  }
  updated(changedProperties) {
    if(changedProperties.has('id')){
      this.requestedAvailability = localStorage.getItem(`request_facility_availability_${this.id}`)
    }
  }
  render() {
    return html`
      <div class="notification-buttons">
        ${
          !this.isDisplayAvailability ? this.renderRequestButton() : html `
          <availability-notification-create-button
            ?isLogin="${this.isLogin}"
            ?isPaidUser="${this.isPaidUser}"
            ?isAdmin="${this.isAdmin}"
            .hasCustomerId="${this.hasCustomerId}"
            @add-notification="${this.addNotification}"
          >
            <button class="orange-outline-square-button">
              <span>"空き状況の通知"を新規追加</span>
              <img src="/images/orange-bell-icon.svg"/>
            </button>
          </availability-notification-create-button>
          ${this.availabilityNotificationsCount > 0 && (this.isPaidUser || this.isAdmin) ? this.renderEditButton() : ''}
          `
        }
      </div>
    `;
  }
}

if (!customElements.get('availability-notification-buttons-in-show'))
customElements.define('availability-notification-buttons-in-show', AvailabilityNotificationButtonsInShow);